

import { mapGetters } from 'vuex';

// Assets
import days from '../assets/data/days';
import minDays from '../assets/data/minDays';

export default {
  name: 'SScheduleWeek',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    week: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      days,
      allDay: 'Tous les jours',
      currentDay: null,
    };
  },
  computed: {
    ...mapGetters({
      getWindowWidth: 'screen/getWindowWidth',
      getCurrentDate: 'transferData/getCurrentDate',
    }),
  },
  watch: {
    // TODO Ajusté
    getWindowWidth: {
      immediate: true,
      handler(value) {
        this.days = value <= 400 ? minDays : days;
      },
    },
  },
  created() {
    if (this.active && this.getCurrentDate) {
      this.currentDay = new Date(this.getCurrentDate).getDay();
    }
  },
  mounted() {
    if (this.$refs[`day-${this.currentDay}`] && this.$refs[`day-${this.currentDay}`].length) {
      setTimeout(() => {
        this.$refs[`day-${this.currentDay}`][0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 250);
    }
  },
  methods: {
    isActive(groupDay) {
      return this.active
        && (
          this.currentDay === groupDay.start
          || (this.currentDay > groupDay.start && this.currentDay <= groupDay.end)
          || (this.currentDay === 0 && (this.currentDay === groupDay.end || groupDay.end === 7))
        );
    },
  },
};

